// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const PrintOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_2652)","fill":"currentColor"},"children":[{"tag":"path","attrs":{"d":"M19 8h-1V3H6v5H5a3 3 0 00-3 3v6h4v4h12v-4h4v-6a3 3 0 00-3-3zM8 5h8v3H8V5zm8 12v2H8v-4h8v2zm2-2v-2H6v2H4v-4a1 1 0 011-1h14a1 1 0 011 1v4h-2z"}},{"tag":"path","attrs":{"d":"M18 12.5a1 1 0 100-2 1 1 0 000 2z"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_2652"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"print","theme":"outlined"};

const PrintOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={PrintOutlinedSvg} />;
  PrintOutlined.displayName = 'PrintOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(PrintOutlined);
